import React from 'react'
import PropTypes from 'prop-types'

// all of useDatepicker props: https://github.com/tresko/react-datepicker/tree/master/packages/hooks#usedatepicker
const DatePickerCoreContext = React.createContext()

export const DatePickerCoreProvider = ({ value, ...rest }) => <DatePickerCoreContext.Provider value={{ disabledDates: [], ...value }} {...rest} />
DatePickerCoreProvider.propTypes = {
  value: PropTypes.shape({ disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)) }),
}

export const useDatePickerCore = () => React.useContext(DatePickerCoreContext)
